module.exports = __webpack_public_path__ + "static/media/payment-success.aac68999.svg";